<h5
    class="mb-2 appTooltip"
    appTooltip="{{consts.TOOLTIP_MESSAGE}}"
    tooltipPosition="right"
>
    {{consts.TITLE}}
    <mat-icon svgIcon="hub_info"></mat-icon>
</h5>
<a class="request-link" href="{{consts.LINK_REQUEST_TOOLS}}" target="_blank">{{consts.LABEL_REQUEST_TOOLS}}</a>
<div class="tools-search-bar">
    <form (click)="resetInputField($event.target.value)">
        <input type="text"
            class="tools-search-input"
            placeholder="{{consts.PLACEHOLDER_SEARCH}}"
            matInput
            autocomplete="off"
            name="searchValue"
            (input)="searchLinks()"
            [(ngModel)]="searchValue"
            #clearInputField
            [appClearInput]= "clearInputField.value"
        >
        <mat-icon
            class="search-icon"
            svgIcon="hub_search"
        >
        </mat-icon>
    </form>
</div>
<div class="row">
    <div class="col">
        <div class="tools-link-container">
            <div class="tools">
                <div
                    *ngFor="let resourceLink of resourceList$ | async"
                    class="tools-container"
                >
                    <div class="flex-item align-items-center">
                        <span
                            (click)="openLink(resourceLink.link)"
                            class="flex-child tools-name"
                            appInsightsTrack
                            [eventData]="{title: resourceLink.name, link: resourceLink.link}"
                            loc="{{consts.TITLE}}"
                            action="{{consts.ACTION_GO}}"
                        >
                            {{resourceLink.name}}
                        </span>
                        <div class="flex-child icon">
                            <mat-icon
                                *ngIf="resourceLink.favorite"
                                svgIcon="hub_star_filled"
                                class="star-icon favorite"
                                (click)="unfavoriteLink(resourceLink)"
                                tooltipPosition="top"
                                appTooltip="Unfavorite {{resourceLink.name}}"
                                appInsightsTrack
                                [eventData]="{title: resourceLink.name, link: resourceLink.link}"
                                loc="{{consts.TITLE}}"
                                action="{{consts.ACTION_UNFAVORITE}}"
                            >
                            </mat-icon>
                            <mat-icon
                                *ngIf="!resourceLink.favorite"
                                svgIcon="hub_star_unfilled"
                                class="star-icon not-favorite"
                                (click)="favoriteLink(resourceLink)"
                                tooltipPosition="top"
                                appTooltip="Favorite {{resourceLink.name}}"
                                appInsightsTrack
                                [eventData]="{title: resourceLink.name, link: resourceLink.link}"
                                loc="{{consts.TITLE}}"
                                action="{{consts.ACTION_FAVORITE}}"
                            >
                            </mat-icon>
                            
                        </div>
                        <div class="flex-child icon">
                            <mat-icon
                                class="arrow-icon"
                                svgIcon="hub_arrow_right"
                                (click)="openLink(resourceLink.link)"
                                tooltipPosition="top"
                                appTooltip="Go to {{resourceLink.name}}"
                                appInsightsTrack
                                [eventData]="{title: resourceLink.name, link: resourceLink.link}"
                                loc="{{consts.TITLE}}"
                                action="{{consts.ACTION_GO}}"
                            >
                            </mat-icon>
                        </div>
                        <div class="flex-child icon">
                            <mat-icon 
                                class="action-icon" 
                                svgIcon="hub_copy_link"
                                ngxClipboard
                                [cbContent]="resourceLink.link"
                                (click)="openCopySnackBar()"                                    
                            >
                            </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
